import { render, staticRenderFns } from "./BarraLateralLogo.vue?vue&type=template&id=d9be90cc&scoped=true&"
import script from "./BarraLateralLogo.vue?vue&type=script&lang=js&"
export * from "./BarraLateralLogo.vue?vue&type=script&lang=js&"
import style0 from "./BarraLateralLogo.vue?vue&type=style&index=0&id=d9be90cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9be90cc",
  null
  
)

export default component.exports